const features = [
  {
    icon: 'ri-smartphone-line',
    title: '手机网页即开即看',
    desc: '无需下载APP，打开手机浏览器就能看电影电视剧，97视频、丝瓜视频等资源高清流畅播放。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-hd-line',
    title: '高清不卡顿播放',
    desc: '先进的视频分发技术保证流畅观影体验，自适应码率根据网络智能调节，告别卡顿等待。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-stack-line',
    title: '海量影视资源',
    desc: '整合蓝莓视频、91在线视频等多渠道资源，电影、电视剧、综艺、动漫、纪录片全覆盖。',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新不剧荒',
    desc: '编辑团队每日精选最新热门内容，院线新片、热播剧集及时上线，追剧不等待。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净观影',
    desc: '无恶意弹窗、无自动下载，做干净的手机网页版观影平台，保护你的隐私和安全。',
    color: 'bg-accent-100 text-accent-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            为什么选择嫩草视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">五大优势，让你爱上手机网页观影</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${item.color} mb-4`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 font-label leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}